var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "      <i style=\"font-size:1.8em;\" class=\"fa fa-globe\" title=\"Change to 2D\"></i>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "      <i  style=\"font-size:1.8em;\" class=\"fa fa-map\" title=\"Change to 3D\"></i>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"changeModeButton\">\n  <button class=\"btn btn-xs changeMapMode\" role=\"button\" style=\"height:34px;\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"enable3D") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "  </button>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/SwitchMapModeView.hbs
// module id = 2061
// module chunks = 0